"use client";

import Link from "next/link";
import { useUserLists } from "@/components/UserListsProvider";

function CompareIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M6 18V9" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M12 18V5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M18 18v-7" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </svg>
  );
}

export function HeaderCompareButton() {
  const { compareCount } = useUserLists();

  return (
    <Link className="header-action-link" href="/compare">
      <span className="header-action-icon">
        <CompareIcon />
      </span>
      <span className="header-action-label">Сравнение</span>
      {compareCount > 0 ? <span className="header-action-count">{compareCount}</span> : null}
    </Link>
  );
}
